/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Enddate1Inputs */

const zh_billing_enddate1 = /** @type {(inputs: Billing_Enddate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束日期`)
};

const en_billing_enddate1 = /** @type {(inputs: Billing_Enddate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End Date`)
};

const es_billing_enddate1 = /** @type {(inputs: Billing_Enddate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de fin`)
};

/**
* | output |
* | --- |
* | "End Date" |
*
* @param {Billing_Enddate1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const billing_enddate1 = /** @type {((inputs?: Billing_Enddate1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Enddate1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_billing_enddate1(inputs)
	if (locale === "en") return en_billing_enddate1(inputs)
	return es_billing_enddate1(inputs)
});
export { billing_enddate1 as "billing_endDate" }